// Naming convention: All lowercase. Does not include ">" character.
export default {
  pm1OrPM2: 'pm1 or pm2',
  roadmapExplorer: 'roadmapExplorer',
  roadmapDeliverable: 'roadmap deliverable',
  digitalOnboarding: 'digital onboarding',
  clientDashboard: 'client dashboard',
  userSettingsSecurity: 'user security settings',
  membershipProfileAddCreditCard: 'membership profile add credit card',
  layout: 'layout',
  whatIf: 'what if tool',
  clientWhatIf: 'client what if tool',
  clientMessages: 'client messages',
  managedAccountPage: 'managed account page',
  addAccounts: 'add accounts',
  knowYourCustomer: 'know your customer',
  foundations: 'foundations',
  managedAccount: 'managed account',
  activation: 'activation',
  accountFunding: 'accountFunding',
  facetQuiz: 'facet-quiz',
  referralPage: 'referral page',
  taxHomePage: 'tax home page',
  wizard: 'wizard',
  upgrade: 'upgrade',
};
